import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';

import PerfectScrollbar from 'perfect-scrollbar';

import Swiper, { Pagination, Autoplay } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination, Autoplay]);

import ImgLazyLoad from './module/img-lazy-load';

document.oncontextmenu = function () {
  return false;
}

if (navigator.platform == "iPad" ||        // -iOS12
  (navigator.platform == "MacIntel" &&   // iPadOS
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1 &&
    navigator.standalone !== undefined)) {
  // document.querySelector("meta[name='viewport']").setAttribute("content", "width=959");
}
class CommonBody {
  constructor($el) {
    this.$el = $el;

    this.$el.find('h2').each((i, e) => {
      let hasOption = false;
      let $optionEl = undefined;
      $(e).addClass('CommonHeading');

      if ($(e).find('a').length) {
        let _a = $(e).find('a');
        _a.addClass('CommonHeading__text');
        $(e).html('<span class="CommonHeading__bg"></span>');
        $(e).append(_a);
      } else {
        if ($(e).find('.CommonHeadingOption')) {
          hasOption = true;
          $optionEl = $(e).find('.CommonHeadingOption');
          $(e).find('.CommonHeadingOption').remove();
          // $(e).remove('.CommonHeadingOption');
        }
        let _text = $(e).html();
        $(e).html('<span class="CommonHeading__bg"></span><span class="CommonHeading__text">' + _text + '</span>');

        if (hasOption) {
          $(e).append($optionEl);
        }
      }

    });
  }
}

class YearSelectMenu {
  constructor(mainApp, $container) {
    this.mainApp = mainApp;
    this.$container = $container;
    this.$container.find('.js-year-select').on('click', (e) => {
      if ($(e.currentTarget).attr('data-year') == 'all') {
        this.selectAll();
      } else {
        this.select($(e.currentTarget).attr('data-year'));
      }
      return false;
    });


    $('#sp-selector-year').change(() => {
      let r = $('#sp-selector-year').val();
      if (r == 'all') {
        this.selectAll();
      } else {
        this.select(r);
      }
    });
  }
  selectAll() {
    this.$container.find('li').each((i, e) => {
      if ($(e).children('a').attr('data-year') == 'all') {
        $(e).addClass('-current');
      } else {
        $(e).removeClass('-current');
      }
    });
    $('.YearBlock').css('display', 'block');
  }
  select(target) {
    let setting = target.split('-');
    this.$container.find('li').each((i, e) => {
      if ($(e).children('a').attr('data-year') == target) {
        $(e).addClass('-current');
      } else {
        $(e).removeClass('-current');
      }
    });
    $('.YearBlock').each((i, e) => {
      let blockYear = parseInt($(e).attr('data-year'));
      if (parseInt(setting[0]) <= blockYear && parseInt(setting[1]) >= blockYear) {
        $(e).css('display', 'block');
      } else {
        $(e).css('display', 'none');
      }
    });
    // this.mainApp.onWindowScroll();
    this.mainApp.scrollPage(0);
    this.mainApp.onWindowScroll();
  }
  select2(target) {
    this.$container.find('li').each((i, e) => {
      if ($(e).children('a').attr('data-year') == target) {
        $(e).addClass('-current');
      } else {
        $(e).removeClass('-current');
      }
    });

    if (target == 'all') {
      $('.YearBlock').css('display', 'block');
    } else {
      $('.YearBlock[data-year="' + target + '"]').css('display', 'block');
      $('.YearBlock:not([data-year="' + target + '"])').css('display', 'none');
    }

    this.mainApp.scrollPage(0);
  }
}

class MainApp {
  constructor() {
    if (this.isTouchDevice()) {
      $('html').addClass('is-touch-device');
      $('a').attr('data-touch', 'true');
      $('button').attr('data-touch', 'true');
    } else {
      $('html').addClass('is-mouse-device');
    }

    this.$window = $(window);
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();
    // this.spMenu = new SpMenu();

    this.prevViewMode = '';
    this.swipers = [];



    $('.swiper-container').each((i, e) => {
      if ($(e).find('.swiper-slide').length > 1) {
        let swiper = new Swiper($(e).get()[0], {
          // Optional parameters
          // direction: 'vertical',
          // loop: true,
          autoHeight: true,

          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },

        })
        swiper.autoplay.stop();
        this.swipers.push(swiper);


      }
    });

    $('.AttentionBody').find('h3').each((i, e) => {
      let _text = $(e).html();
      //console.log('置き換えテキスト', _text);
      $(e).html('<span>' + _text + '</span>');
      let addClass = 'SimpleHeading SimpleHeading--fs-28 SimpleHeading--underline';
      if ($(e).hasClass('AnchorTarget')) {
        addClass += ' AnchorTarget';
      }

      $(e).attr('class', addClass);
      // console.log($(e).text());
    });

    this.inviewObject = [];
  }

  isTouchDevice() {
    return ('ontouchstart' in window || navigator.msPointerEnabled) ? true : false;
  }

  init() {

    // this.viewMode             = 'pc';
    this.isTablet = false;
    this.onLoadComplete = true;

    this.isShowProjectFooter = true;
    this.imgLazyLoad = new ImgLazyLoad(this);
    // this.spMenu               = new SpMenu(this);

    this.isHome = false;
    if ($('body').hasClass('home')) {
      this.isHome = true;
    }

    if ($('.CommonBody').length) {
      new CommonBody($('.CommonBody'));
    }

    // const container = document.querySelector('#add-scrollbar');

    if ($('#add-scrollbar').length) {
      new PerfectScrollbar('#add-scrollbar', {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
      });
    }

    if ($('.YearSelectMenu').length) {
      new YearSelectMenu(this, $('.YearSelectMenu'));
    }

    $('.BtnToggleCommonHeader').on('click', () => {
      if ($('body').hasClass('is-open-sp-common-header')) {
        $('body').removeClass('is-open-sp-common-header');
      } else {
        $('body').addClass('is-open-sp-common-header');
      }
    });


    $('.BtnToggleAccordion').on('click', (e) => {
      let targetId = $(e.currentTarget).attr('data-id');
      let $target = $('.Accordion-' + targetId);

      if ($target.hasClass('Accordion--close')) {
        $(e.currentTarget).removeClass('BtnToggleAccordion--close');
        $target.removeClass('Accordion--close')
        let contentHeight = $target.children('.Accordion__content').height();

        $target.stop(false).animate({ 'height': contentHeight }, 400, 'easeOutExpo', () => {
          $target.css({
            'height': 'auto',
            'overflow': 'auto'
          });
        });
      } else {
        $(e.currentTarget).addClass('BtnToggleAccordion--close');
        $target.addClass('Accordion--close')
        $target.stop(false).css('overflow', 'hidden');
        $target.animate({ 'height': 0 }, 400, 'easeOutExpo');
      }
    });

    this.isOpenSpMenu = false;
    $('.BtnToggleSpMenu').on('click', () => {
      if (this.isOpenSpMenu) {
        this.isOpenSpMenu = false;
        $('body').removeClass('open-sp-menu');
        $('.HeaderLogo').removeClass('HeaderLogo--fadeout');
        $('.SpMenu').stop(false).animate({ 'opacity': 0 }, 400, 'easeOutExpo', () => {
          $('.SpMenu').css({ 'opacity': 0, 'display': 'none' });
        });
      } else {
        this.isOpenSpMenu = true;
        $('body').addClass('open-sp-menu');
        $('.HeaderLogo').addClass('HeaderLogo--fadeout');
        $('.SpMenu').stop(false).css({ 'opacity': 0, 'display': 'block' }).animate({ 'opacity': 1 }, 400, 'easeOutExpo');
      }
    });

    $('.ScrollDown').on('click', () => {
      let initTop = $('.HomeTopics__title').offset()['top'];
      if ($('.RightArea').height() - initTop < window.innerHeight) {
        initTop = $('.RightArea').height() - window.innerHeight;
      }

      this.scrollPage(initTop);
    });

    this.scrollableElement = null;
    let firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
    if ('scrollingElement' in document) {
      this.scrollableElement = document.scrollingElement;
    } else if (/*@cc_on!@*/false || (!!window.MSInputMethodContext && !!document.documentMode)) {
      this.scrollableElement = document.documentElement;
    } else if (firefox && parseInt(firefox[1]) <= 47) {
      this.scrollableElement = document.documentElement;
    } else {
      this.scrollableElement = document.body;
    }

    if ($('body').hasClass('post-type-archive-topics')) {
      if (String(location.hash).length > 1) {
        let _hash = location.hash.slice(1);

        if ($('h2[data-id="' + _hash + '"]').length) {
          setTimeout(() => {
            this.scrollPage($('h2[data-id="' + _hash + '"]').offset()['top']);
          }, 100);

        }
      }
    }

    $('#sp-selector-category').change(() => {
      let r = $('#sp-selector-category').val();
      if (String(r).length > 0) {
        location.href = r;
      }
    });

    $('button.BtnLocalNav').on('click', (e) => { //特設サイト用のスクロール処理
      if ($(e.currentTarget).hasClass('js-sp-localnav')) {
        $('.CommonSpMenu').css('display', 'none');
        if ($('body').hasClass('is-open-sp-common-header')) {
          $('body').removeClass('is-open-sp-common-header');
        }
      }
      // console.log('target offsettop', $('.AnchorTarget[data-id="' + $(e.currentTarget).attr('data-target') + '"]').offset()['top']);
      if ($(e.currentTarget).attr('data-target') == 'anchor-top') {
        this.scrollPage(0);
      } else {
        this.scrollPage($('.AnchorTarget[data-id="' + $(e.currentTarget).attr('data-target') + '"]').offset()['top']);
      }

    });
    $('.js-localnav').on('click', (e) => {
      if ($(e.currentTarget).attr('data-target') == 'anchor-top') {
        this.scrollPage(0);
      } else {
        let target = $('.AnchorTarget[data-id="' + $(e.currentTarget).attr('data-target') + '"]').offset()['top'];
        if ($(e.currentTarget).attr('data-target') == 'covid19') {
          target -= 100;
        }
        this.scrollPage(target);
      }
    });

    $('.SpToggleCastComment').on('click', (e) => {
      $(e.currentTarget).parent().addClass('CastComment--sp-show');
      console.log('click1');
    });
    $('.SpBtnCloseComment').on('click', (e) => {
      $(e.currentTarget).parent().parent().removeClass('CastComment--sp-show');
      $(e.currentTarget).parent().parent().parent().removeClass('CastComment--sp-show');
      console.log('click2');
    });

    let prevSelectValue = '';
    $('.LocalNavSelect').on('click', () => {
      prevSelectValue = $('.LocalNavSelect').val();
    });

    this.isCheckDoubleSelect = false;
    $('.LocalNavSelect').change((e) => {
      if (this.isCheckDoubleSelect) {
        e.preventDefault();
        return false;
      }
      let target = $('.LocalNavSelect').val();
      if (target.slice(0, 4) == 'http') {
        window.open(target, '_blank');

        e.preventDefault();
        $('.LocalNavSelect').val(prevSelectValue);
        return false;
      }
      if (target == 'anchor-top') {
        this.scrollPage(0);
      } else {
        this.scrollPage($('.AnchorTarget[data-id="' + target + '"]').offset()['top']);
      }

      // sconsole.log('target offset top ', $('.AnchorTarget[data-id="' + target + '"]').offset()['top']);

      this.isCheckDoubleSelect = true;
      this.doubleSelectInterval = setInterval(() => {
        clearInterval(this.doubleSelectInterval);
        this.isCheckDoubleSelect = false;
      }, 100);
      // console.log($('.LocalNavSelect').val());
    });

    if ($('.NewsList').length) {
      let cropHeight = 0;
      let originalHeight = $('.NewsList').height();
      $('.NewsList').find('li').each((i, e) => {
        if (i < 4) {
          cropHeight += parseInt($(e).outerHeight());
        }
      });

      $('.NewsList').css({
        'overflow': 'hidden',
        'height': cropHeight
      });

      $('.js-remove-panel').on('click', () => {
        $('.HidePanel').css({ 'pointer-events': 'none' }).animate({ 'opacity': 0 }, 700, 'easeInOutSine', () => {
          $('.HidePanel').css({ 'display': 'none' });
        });
        $('.NewsList').animate({ 'height': originalHeight }, 1000, 'easeInOutExpo', () => {
          $('.NewsList').css({
            'height': 'auto',
            'overflow': 'visible'
          });
        });
      });
    }

    if ($('.MediaList').length) {
      let cropHeight = 0;
      let originalHeight = $('.MediaList').height();
      $('.MediaList').find('li').each((i, e) => {
        if (i < 4) {
          cropHeight += parseInt($(e).outerHeight());
        }
      });

      $('.MediaList').css({
        'overflow': 'hidden',
        'height': cropHeight
      });

      $('.js-remove-panel--Media').on('click', () => {
        $('.HidePanel--Media').css({ 'pointer-events': 'none' }).animate({ 'opacity': 0 }, 700, 'easeInOutSine', () => {
          $('.HidePanel--Media').css({ 'display': 'none' });
        });
        $('.MediaList').animate({ 'height': originalHeight }, 1000, 'easeInOutExpo', () => {
          $('.MediaList').css({
            'height': 'auto',
            'overflow': 'visible'
          });
        });
      });
    }

    $('.BtnBackToTop').on('click', () => {
      this.scrollPage(0);
    });


    this.$window
      .on('resize', () => {
        this.onWindowResize();
      })
      .on('scroll', () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }

  scrollPage(val, isCancelTransition = false) {
    if ($('html').hasClass('ua-mobile')) {
      val -= 60;
    }
    if (isCancelTransition) {
      $(this.scrollableElement).stop(false).scrollTop(val);
    } else {
      $(this.scrollableElement).stop(false).animate(
        { 'scrollTop': val },
        300,
        'easeOutExpo'
      );
    }
  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if (this.scrollTop < 0) this.scrollTop = 0;

    if (this.pageApp != undefined) {
      this.pageApp.onWindowScroll(this.scrollTop);
    }

    if (this.scrollTop != this.prevScrollTop) {
      if (this.scrollTop > this.prevScrollTop) {
        this.scrollDiff = 1;
      } else {
        this.scrollDiff = -1;
      }
    }

    if (this.isHome) {
      if (this.scrollTop > 10) {
        $('.ScrollDown').addClass('ScrollDown--hide');
      } else {
        $('.ScrollDown').removeClass('ScrollDown--hide');
      }
    }

    if (this.scrollTop > 10) {
      $('.BtnBackToTop').addClass('BtnBackToTop--show');
    } else {
      $('.BtnBackToTop').removeClass('BtnBackToTop--show');
    }

    if (this.imgLazyLoad != undefined) {
      this.imgLazyLoad.update(this.scrollTop, this.windowHeight);
    }

    this.prevScrollTop = this.scrollTop;
  }


  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    this.inviewPosition = Math.floor(this.windowHeight * 0.7);

    if ($('.Main--min-height').length) {
      let linitHeight = window.innerHeight - (parseInt($('.Main').css('padding-top')) + parseInt($('.Main').css('padding-bottom')));
      if (linitHeight < $('.VerticalAlignCenter__content').height()) {
        $('.Main--min-height').addClass('Main--min-height-active-scroll');
      } else {
        $('.Main--min-height').removeClass('Main--min-height-active-scroll');
      }
    }

    if ($('body').hasClass('home')) {
      let heroContainerWidth = Math.floor($('.HeroSlide').width());
      let heroContainerHeight = Math.floor(window.innerHeight * 0.9);
      $('.img-vertical').each((i, e) => {
        if ($(e).width() > heroContainerWidth) {
          $(e).addClass('-fix-width');
        }
        if ($(e).height() > heroContainerHeight) {
          $(e).removeClass('-fix-width');
        }
      });
    }

    this.prevViewMode = this.viewMode;

    this.onWindowScroll();
  }

  onLoad() {
    this.onWindowResize();

    if ($('body').hasClass('home')) {
      // $('body').addClass('fadein');

      let heroContainerWidth = Math.floor($('.HeroSlide').width());
      let heroContainerHeight = Math.floor(window.innerHeight * 0.9);
      $('.img-vertical').each((i, e) => {
        if ($(e).width() > heroContainerWidth) {
          $(e).addClass('-fix-width');
        } else if ($(e).height() > heroContainerHeight) {
          $(e).removeClass('-fix-width');
        }
      });


      setTimeout(() => {
        $('body').addClass('fadein');
        setTimeout(() => {
          $('.ScrollDown').addClass('ScrollDown--show');
          $('.Topics').css('display', 'block');

          this.swipers[0].autoplay.start();
        }, 3500);

        setTimeout(() => {
          $('body').addClass('fadein-complete');
        }, 4000);


      }, 500);

    }
  }
}

let mainApp = new MainApp();

$('document').ready(() => {
  mainApp.init();

  $(document).on('touchstart', 'a, button', (e) => {
    $(e.currentTarget).attr('data-touch', 'true');
  });

  $(document).on('mouseleave', 'a, button', (e) => {
    $(e.currentTarget).removeAttr('data-touch');
  });
});

$(window).on('load', () => {
  mainApp.onLoad();
});


